import React from "react";
import "./Footer.css";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Apply Here Section */}
        <div className="footer-column">
          <h3>BOOK NOW</h3>
          <ul>
            <li><a href="/contact">Online Booking</a></li>
            <li><a href="/contact">How to Book ?</a></li>
            <li><a href="/booking">Availablity</a></li>
          </ul>
        </div>

        {/* Learn Here Section */}
        <div className="footer-column">
          <h3>FACILITIES</h3>
          <ul>
            <li><a href="/banquite-facilities">Large Area for Marriage</a></li>
            <li><a href="/recreational-amenties">Swimming Pool</a></li>
            <li><a href="/hotel-rooms">Relaxation Rooms</a></li>
            
          </ul>
        </div>

        {/* Visit Here Section */}
        <div className="footer-column">
          <h3>IMPORTANT LINKS</h3>
          <ul>
            <li><a href="/about">ABOUT</a></li>
            <li><a href="/hotel-rooms">ACCOMMODATION</a></li>
            <li><a href="/contact">CONTACT US</a></li>
            <li><a href="/banquite-facilities">BANQUITE FACILITIES</a></li>
            <li><a href="/recreational-facilities">RECREATIONAL FACILITIES</a></li>
            <li><a href="/outdoor">OUTDOOR SPACES</a></li>
            <li><a href="/amenties">ADDITIONAL AMENITIES</a></li>
            
          

          </ul>
        </div>

        {/* Get in Touch Section */}
        <div className="footer-column">
          <h3>GET IN TOUCH</h3>
          <address>
            <p>
              <FaMapMarkerAlt className="footer-icon" />THE GOLDEN PALACE<br />
              Near Rahman gate, Pushkar Highway, <br/>
               Didwana (341303), Rajasthan, India
            </p>
            <p>
              <FaPhoneAlt className="footer-icon" /> 
              <a href="tel:+917351408009">+91 9001710160, <br/> +91 8058753950 <br/> +91 9414548063</a>
            </p>
            <p>
              <FaEnvelope className="footer-icon" /> 
              <a href="mailto:contact@apex.ac.in">thegoldenpalacedidwana@gmail.com</a>
            </p>
            <p>
              <a href="https://maps.app.goo.gl/BFs2tVUYS4rPmmKj9">Open in Google Maps</a>
            </p>
          </address>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="footer-social">
        <a href="#"><FaFacebookF /></a>
        <a href="#"><FaTwitter /></a>
        <a href="#"><FaInstagram /></a>
        <a href="#"><FaYoutube /></a>
      </div>

      <div className="footer-bottom">
  <p>
    Design & Developed By{" "}
    <a 
      href="https://www.anvide.com" 
      target="_blank" 
      rel="noopener noreferrer"
      className="footer-link"
    >
      Ananta Infotech
    </a>
        {" "}
    <a 
      href="https://www.instagram.com" 
      target="_blank" 
      rel="noopener noreferrer"
      className="footer-icon-link"
    >
      <FaInstagram className="footer-icon" />
     
    </a>
    {/* &{" "}

    <a 
      href="https://www.anvide.com" 
      target="_blank" 
      rel="noopener noreferrer"
      className="footer-link"
    >
      Team Anvide
    </a>
     */}
  </p>
  <p>
    © All rights reserved 2025
  </p>
</div>

     
    </footer>
  );
};

export default Footer;
